import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useBackgroundRefetch } from '@/components/AppBar/NetworkPopover/hooks/useNetworks';
import { mutationWithFeedback } from '@/utils/toast';
import { trpc } from '@/utils/trpc';
const useNetworkDelete = () => {
  const $ = _c(8);
  const refetchInBackground = useBackgroundRefetch();
  let t0;
  if ($[0] !== refetchInBackground) {
    t0 = {
      onSettled: () => refetchInBackground()
    };
    $[0] = refetchInBackground;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    mutateAsync: deleteNetwork,
    isPending,
    variables
  } = trpc.network.deleteNetwork.useMutation(t0);
  let t1;
  if ($[2] !== deleteNetwork) {
    t1 = async id => {
      await mutationWithFeedback({
        mutation: deleteNetwork({
          id
        }),
        successText: "Deleted network",
        errorText: "Failed to delete network"
      });
    };
    $[2] = deleteNetwork;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const mutate = t1;
  let t2;
  if ($[4] !== isPending || $[5] !== mutate || $[6] !== variables) {
    t2 = {
      mutate,
      isPending,
      variables
    };
    $[4] = isPending;
    $[5] = mutate;
    $[6] = variables;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default useNetworkDelete;